class AlgoliaIconCloseSmall extends HTMLElement {
  constructor() {
    super();

    this.render = this.render.bind(this);
  }

  /**
   * Renders the icon content.
   * @returns {string} The rendered icon.
   */
  render() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('width', '12');
    svg.setAttribute('height', '13');
    svg.setAttribute('class', 'icon icon-close-small');
    svg.setAttribute('viewBox', '0 0 12 13');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    
    const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path1.setAttribute('d', 'M8.48627 9.32917L2.82849 3.67098');
    path1.setAttribute('stroke', 'currentColor');
    path1.setAttribute('stroke-linecap', 'round');
    path1.setAttribute('stroke-linejoin', 'round');

    const path2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path2.setAttribute('d', 'M2.88539 9.38504L8.42932 3.61524');
    path2.setAttribute('stroke', 'currentColor');
    path2.setAttribute('stroke-linecap', 'round');
    path2.setAttribute('stroke-linejoin', 'round');

    svg.appendChild(path1);
    svg.appendChild(path2);

    return svg;
  }
}

customElements.define("algolia-icon-close-small", AlgoliaIconCloseSmall);